import { render, staticRenderFns } from "./NovoAtrasoJustificadoPage.vue?vue&type=template&id=5497d4cc&scoped=true"
import script from "./NovoAtrasoJustificadoPage.vue?vue&type=script&lang=js"
export * from "./NovoAtrasoJustificadoPage.vue?vue&type=script&lang=js"
import style0 from "./NovoAtrasoJustificadoPage.vue?vue&type=style&index=0&id=5497d4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497d4cc",
  null
  
)

export default component.exports